import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiManagersEmployeeSurveyQuestionsMutateResponseType,
  ApiManagersEmployeeSurveyQuestionsMutateRequestType,
} from "~/domains";

type RequestDataType = {
  employeeSurveyId: string;
  body: ApiManagersEmployeeSurveyQuestionsMutateRequestType;
};

const request = ({ employeeSurveyId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ employeeSurveyQuestion: body });
  return new ApiClient()
    .post<ApiManagersEmployeeSurveyQuestionsMutateResponseType>(
      `/api/managers/employee_surveys/${employeeSurveyId}/employee_survey_questions`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersEmployeeSurveysEmployeeSurveyQuestionsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeeSurveyQuestionsMutateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
